import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message } from 'element-ui'
import { getToken, hasPerm } from '../auth/session'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'login', component: () => import('../views/Login.vue'), meta: { public: true } },
  {
    path: '/public/prerecord-review/:id/:token',
    name: 'public-prerecord-review',
    component: () => import('../views/PublicPrerecordReview.vue'),
    meta: { public: true, pageTitle: '预录资料外协审核' },
  },
  {
    path: '/public/provider-assist/:id/:token',
    name: 'public-provider-assist',
    component: () => import('../views/PublicPrerecordReview.vue'),
    meta: { public: true, pageTitle: '外协协助汇总' },
  },
  {
    path: '/public/customer-assist/:id/:token',
    name: 'public-customer-assist',
    component: () => import('../views/PublicCustomerAssist.vue'),
    meta: { public: true, pageTitle: '客户报关资料汇总' },
  },
  {
    path: '/public/customer-declaration/:id/:token',
    name: 'public-customer-declaration',
    component: () => import('../views/PublicCustomerDeclaration.vue'),
    meta: { public: true, pageTitle: '报关资料查阅' },
  },
  { path: '/', redirect: '/dashboard' },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard.vue'),
  },
  {
    path: '/containers',
    name: 'containers',
    component: () => import('../views/Containers.vue'),
    meta: { pageTitle: '货柜管理' },
  },
  {
    path: '/containers/inspection',
    name: 'containers-inspection',
    component: () => import('../views/InspectionContainers.vue'),
    meta: { pageTitle: '查验货柜' },
  },
  {
    path: '/containers/lcl-operations',
    name: 'containers-lcl-operations',
    component: () => import('../views/ContainerLclOperations.vue'),
    meta: { pageTitle: '拼柜节点管理' },
  },
  {
    path: '/container-documents',
    name: 'container-documents',
    component: () => import('../views/ContainerDocuments.vue'),
    meta: { pageTitle: '货柜单据' },
  },
  {
    path: '/declarations',
    redirect: '/declarations/formal',
  },
  {
    path: '/declarations/prerecord',
    name: 'declarations-prerecord',
    component: () => import('../views/Declarations.vue'),
    meta: { declarationMode: 'prerecord', pageTitle: '预录报关单' },
  },
  {
    path: '/declarations/first-review',
    redirect: '/declarations/review',
  },
  {
    path: '/declarations/review',
    name: 'declarations-review',
    component: () => import('../views/Declarations.vue'),
    meta: { declarationMode: 'review', pageTitle: '报关单审核' },
  },
  {
    path: '/declarations/publish-notify',
    name: 'declarations-publish-notify',
    component: () => import('../views/Declarations.vue'),
    meta: { declarationMode: 'publishNotify', pageTitle: '报关单通知' },
  },
  {
    path: '/declarations/publish',
    name: 'declarations-publish',
    component: () => import('../views/Declarations.vue'),
    meta: { declarationMode: 'publish', pageTitle: '报关单待核对' },
  },
  {
    path: '/declarations/publish-confirm',
    name: 'declarations-publish-confirm',
    component: () => import('../views/Declarations.vue'),
    meta: { declarationMode: 'publishConfirm', pageTitle: '报关单确认' },
  },
  {
    path: '/declarations/formal',
    name: 'declarations-formal',
    component: () => import('../views/Declarations.vue'),
    meta: { declarationMode: 'formal', pageTitle: '报关单' },
  },
  {
    path: '/declarations/batch-file-query',
    name: 'declarations-batch-file-query',
    component: () => import('../views/DeclarationBatchFileQuery.vue'),
    meta: { pageTitle: '报关单文件查询' },
  },
  {
    path: '/cutoffs',
    name: 'cutoffs',
    component: () => import('../views/Cutoffs.vue'),
    meta: { pageTitle: '截单管理' },
  },
  {
    path: '/cutoffs/provider-profiles',
    name: 'cutoff-provider-profiles',
    component: () => import('../views/CutoffProviderProfiles.vue'),
    meta: { pageTitle: '截单服务商资料' },
  },
  {
    path: '/clearances',
    name: 'clearances',
    component: () => import('../views/Clearances.vue'),
  },
  {
    path: '/pickups',
    name: 'pickups',
    component: () => import('../views/Pickups.vue'),
  },
  {
    path: '/fees',
    name: 'fees',
    component: () => import('../views/FeeCenter.vue'),
  },
  {
    path: '/ports',
    name: 'ports',
    component: () => import('../views/Ports.vue'),
  },
  {
    path: '/providers',
    name: 'providers',
    component: () => import('../views/Providers.vue'),
  },
  {
    path: '/customers',
    name: 'customers',
    component: () => import('../views/Customers.vue'),
    meta: { pageTitle: '客户管理' },
  },
  {
    path: '/declaration-uploads',
    component: () => import('../views/DeclarationUploadsLayout.vue'),
    redirect: '/declaration-uploads/batch',
    meta: { pageTitle: '上传管理' },
    children: [
      {
        path: 'batch',
        name: 'declaration-uploads-batch',
        component: () => import('../views/DeclarationUploadBatch.vue'),
        meta: { pageTitle: '报关单批量上传' },
      },
      {
        path: 'links',
        name: 'declaration-uploads-links',
        component: () => import('../views/DeclarationUploadLinks.vue'),
        meta: { pageTitle: '关联数据' },
      },
    ],
  },
  {
    path: '/system/users',
    name: 'system-users',
    component: () => import('../views/SystemUsers.vue'),
    meta: { pageTitle: '用户管理' },
  },
  {
    path: '/system/roles',
    name: 'system-roles',
    component: () => import('../views/SystemRoles.vue'),
    meta: { pageTitle: '角色管理' },
  },
  {
    path: '/system/permissions',
    name: 'system-permissions',
    component: () => import('../views/SystemPermissions.vue'),
    meta: { pageTitle: '权限管理' },
  },
  {
    path: '/system/settings',
    name: 'system-settings',
    component: () => import('../views/SystemSettings.vue'),
    meta: { pageTitle: '系统设置' },
  },
  {
    path: '/system/async-mail-jobs',
    name: 'system-async-mail-jobs',
    component: () => import('../views/AsyncMailJobs.vue'),
    meta: { pageTitle: '异步邮件任务' },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

const routePermRules = [
  ['/dashboard', ['menu.dashboard', 'dashboard.read']],
  ['/containers/lcl-operations', ['menu.containers', 'containers.read']],
  ['/containers', ['menu.containers', 'containers.read']],
  ['/container-documents', ['menu.containers', 'containers.read']],
  ['/declarations/prerecord', ['menu.declarations.prerecord', 'declarations.prerecord.read', 'declarations.read']],
  ['/declarations/review', ['menu.declarations.review', 'declarations.review.read', 'declarations.read']],
  ['/declarations/publish-notify', ['menu.declarations.publish', 'declarations.publish.read', 'declarations.read']],
  ['/declarations/publish', ['menu.declarations.publish', 'declarations.publish.read', 'declarations.read']],
  ['/declarations/publish-confirm', ['menu.declarations.publish', 'declarations.publish.read', 'declarations.read']],
  ['/declarations/formal', ['menu.declarations.formal', 'declarations.formal.read', 'declarations.read']],
  [
    '/declarations/batch-file-query',
    [
      'menu.declarations.batch_file_query',
      'menu.declaration_uploads',
      'menu.declaration_uploads.batch',
      'menu.declaration_uploads.links',
      'declaration_uploads.read',
      'declaration_uploads.write',
    ],
  ],
  ['/declarations', 'declarations.read'],
  ['/cutoffs', ['menu.cutoffs', 'cutoffs.read']],
  ['/clearances', ['menu.clearances', 'clearances.read']],
  ['/pickups', ['menu.pickups', 'pickups.read']],
  ['/fees', ['menu.fees', 'fees.read']],
  ['/ports', ['menu.ports', 'ports.read']],
  ['/providers', ['menu.providers', 'providers.read']],
  ['/customers', ['menu.customers', 'customers.read']],
  [
    '/declaration-uploads/batch',
    [
      'menu.declaration_uploads.batch',
      'menu.declaration_uploads',
      'declaration_uploads.read',
      'declaration_uploads.write',
    ],
  ],
  [
    '/declaration-uploads/links',
    [
      'menu.declaration_uploads.links',
      'menu.declaration_uploads',
      'declaration_uploads.read',
      'declaration_uploads.write',
    ],
  ],
  [
    '/declaration-uploads',
    [
      'menu.declaration_uploads',
      'menu.declaration_uploads.batch',
      'menu.declaration_uploads.links',
      'declaration_uploads.read',
      'declaration_uploads.write',
    ],
  ],
  ['/system/users', ['menu.system.users', 'users.read']],
  ['/system/roles', ['menu.system.roles', 'roles.read']],
  ['/system/permissions', ['menu.system.permissions', 'permissions.read']],
  ['/system/settings', ['menu.system.settings', 'settings.read']],
  ['/system/async-mail-jobs', ['menu.system.mail_jobs', 'async_mail_jobs.read']],
]

function requiredPermission(path) {
  for (const [prefix, code] of routePermRules) {
    if (path === prefix || path.startsWith(prefix + '/')) {
      return code
    }
  }
  return null
}

function hasAnyPerm(codes) {
  if (!Array.isArray(codes)) return false
  return codes.some((c) => hasPerm(c))
}

/**
 * 免登录可访问的路由。
 * 除 meta.public 外，还须以路径为准：`matched` 在首屏/个别部署下偶发为空时，仅依赖 meta 会把 /public/* 误判进登录页。
 */
function routeIsPublic(to) {
  const p = to && to.path ? String(to.path) : ''
  if (p === '/login' || p.startsWith('/public/')) {
    return true
  }
  return to.matched.some((r) => r.meta && r.meta.public)
}

router.beforeEach((to, from, next) => {
  if (routeIsPublic(to)) {
    if (getToken() && to.path === '/login') {
      next({ path: '/dashboard' })
    } else {
      next()
    }
    return
  }
  if (!getToken()) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  const need = requiredPermission(to.path)
  if ((Array.isArray(need) && !hasAnyPerm(need)) || (typeof need === 'string' && need && !hasPerm(need))) {
    Message.warning('无权访问该页面')
    next(false)
    return
  }
  next()
})

export default router
